module.exports = "img/flags/UZ.cadf94d.png";